<!--
 * @Author: RYL
 * @Description:项目分组添加、编辑组件
 * @Date: 2020-10-16 14:20:14
 * @LastEditTime: 2022-03-07 18:44:40
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog
      :visible.sync="dialogVisible"
      :title="
        type === 'edit'
          ? `${$t('lang.projectList.EditProject')}`
          : `${$t('lang.projectList.AddProject')}`
      "
      center
      width="30%"
    >
      <div class="group-form">
        <el-form
          :model="editData"
          ref="groupForm"
          label-width="150px"
          label-position="right"
          :rules="rules"
        >
          <el-form-item
            :label="`${$t('lang.projectList.name')}：`"
            prop="groupName"
          >
            <el-input
              size="mini"
              clearable
              :placeholder="$t('lang.Input.inputPlaceholder')"
              v-model="editData.groupName"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('lang.projectList.projectType') + '：'"
            prop="groupMonitorType"
          >
            <el-select
              size="mini"
              :value="typeObj[editData.groupMonitorType]"
              @change="typeChange"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="`${$t('lang.projectList.BelogingCustomer')}：`"
            prop="groupCtid"
            v-if="
              user_iscustomer == 2 || (user_iscustomer == 1 && user_ctid == 0)
            "
          >
            <el-select
              v-model="editData.groupCtid"
              :placeholder="$t('lang.Input.placeholder')"
              filterable
              clearable
              size="mini"
            >
              <el-option
                v-for="item in Customer"
                :key="item.c_id"
                :label="item.c_name"
                :value="item.c_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="`${$t('lang.projectList.BelogingUser')}：`"
            prop="userName"
            v-if="user_iscustomer == 0 || user_ctid != 0"
          >
            <el-select
              v-model="editData.uid"
              :placeholder="$t('lang.groupinglist.Optional')"
              filterable
              clearable
              size="mini"
            >
              <el-option
                v-for="item in UserList"
                :key="item.user_id"
                :label="item.username"
                :value="item.user_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="`${$t('lang.projectList.FirstProjectGroup')}：`"
            prop="groupLevel1"
          >
            <el-select
              v-model="editData.groupPid"
              filterable
              clearable
              :placeholder="$t('lang.Input.placeholder')"
              size="mini"
            >
              <el-option
                v-for="item in projectList"
                :key="item.groupId"
                :label="item.groupName"
                :value="item.groupId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="dialogVisible = false">{{
          $t("lang.Button.cancel")
        }}</el-button>
        <el-button size="mini" type="primary" @click="submitForm">{{
          $t("lang.Button.submit")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  editProjectGroup,
  addProjectGroup,
  getFirstGroup,
} from "@/api/cloudMonitor/projectGroup";
import { addProject } from "@/mixins/addProject";
export default {
  mixins: [addProject],
  data() {
    return {
      dialogVisible: false,
      typeObj: {
        0: this.$t("lang.projectList.generictype"),
        1: "中建三局",
      },
      typeOptions: [
        {
          label: this.$t('lang.projectList.generictype'),
          value: "0",
        },
        {
          label: "中建三局",
          value: "1",
        },
      ],
      type: "", // 添加或编辑
    };
  },
  methods: {
    show(item) {
      this.clearData();
      if (
        this.user_iscustomer == 2 ||
        (this.user_iscustomer == 1 && this.user_ctid == 0)
      ) {
        this.getCustomer();
      } else if (this.user_iscustomer == 0 || this.user_ctid != 0) {
        this.getUser();
      }
      if (item) {
        this.editData.groupId = item.groupId;
        this.editData.groupPid = item.groupPid;
        this.editData.groupCtid = item.groupCtid;
        this.editData.groupName = item.groupName;
        this.editData.groupLevel = item.groupLevel;
        this.editData.groupMonitorType = item.groupMonitorType;
        this.editData.uid = item.uid;
        this.type = "edit";
      } else {
        this.type = "add";
      }
      this.getFirstList();
      this.dialogVisible = true;
    },
    // 提交修改
    submitForm() {
      this.$refs["groupForm"].validate((valid) => {
        if (valid) {
          if (this.editData.groupPid) {
            this.editData.groupLevel = 2;
          } else {
            this.editData.groupLevel = 1;
            this.editData.groupPid = 0;
          }
          if (this.type === "edit") {
            // 编辑
            editProjectGroup(this.editData)
              .then((res) => {
                if (res.data.code === 0) {
                  this.$message.success(
                    `${this.$t("lang.Confirm.SuccessfullyEdit")}`
                  );
                  if (this.editData.groupPid) {
                    this.$emit("reFleshTable", this.editData.groupPid);
                  } else {
                    this.$emit("updateList");
                  }
                  this.dialogVisible = false;
                } else {
                  this.$message.error(`${this.$t("lang.Confirm.EditFailed")}`);
                }
              })
              .catch(() => {});
          } else {
            // 添加
            if (this.editData.groupPid) {
              this.editData.groupLevel = 2;
            } else {
              this.editData.groupLevel = 1;
              this.editData.groupPid = 0;
            }
            addProjectGroup(this.editData)
              .then((res) => {
                if (res.data.code === 0) {
                  this.$message.success(
                    `${this.$t("lang.Confirm.SuccessfullyAdd")}`
                  );
                  if (this.editData.groupPid) {
                    this.$emit("reFleshTable", this.editData.groupPid);
                  } else {
                    this.$emit("updateList");
                  }
                  this.dialogVisible = false;
                } else {
                  this.$message.error(`${this.$t("lang.Confirm.AddFailed")}`);
                }
              })
              .catch(() => {});
          }
        } else {
          return false;
        }
      });
    },
    typeChange(e) {
      this.editData.groupMonitorType = e;
    },
  },
};
</script>
<style scoped>
.form-input {
  width: 4rem;
}
.group-form {
  display: flex;
  justify-content: center;
}
</style>
